export default {
    messages: {
        "navbar.links.discover": "Descubre UBISOFT+",
        "navbar.links.store": "Tienda",
        "navbar.links.news": "Noticias",
        "navbar.links.forum": "Foro",
        "navbar.links.support": "Atención al Cliente",
        "navbar.links.status": "Mi estado",
        "navbar.links.featured": "Destacado",
        "navbar.links.rewards": "Canjear",
        "navbar.links.library": "Todos los juegos",
        "navbar.links.benefits": "Recompensas de UBISOFT+",
        "navbar.links.subscription": "Gestionar mi suscripción",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "Todos los juegos",
        "heading.my_games": "Continuar jugando",
        "heading.popular_games": "Los juegos más populares",
        "heading.recommended_games": "Recomendado para ti",
        "action.load_more_games": "Cargar más juegos",
        "action.search_for_game": "Buscar un juego",
        "action.launch_game": "Iniciar juego",
        "action.activate_game": "Activar juego",
        "filters.brand": "Filtra por Saga",
        "filters.game_name": "A - Z",
        "filters.release_date": "Fecha de lanzamiento",
        "filters.show_all": "Mostrar todo",
        "filters.sort": "Filtrar por",
        "filters.all": "Todo",
        "filters.activated": "Activados",
        "message.no_activated_games": "Ningún juego coincide con tu búsqueda",
        "message.already_owned": "Ya tienes este juego",
        "message.no_available_games": "Ningún juego coincide con tu búsqueda",
        "message.no_search_results": "Ningún juego coincide con tu búsqueda",
        "message.error": "¡Lo sentimos! Se ha producido un error al procesar tu solicitud",
        "message.refresh_page": "Haz clic aquí para volver a intentarlo",
        "message.no_subscription": "No tienes ninguna suscripción activa",
        "warning.savefiles_alert.title": "Mensaje importante sobre archivos de guardado",
        "warning.savefiles_alert.body": "La actualización a la edición disponible en UBISOFT + afectará a tus archivos guardados, incluida tu progresión actual en el juego. Si finaliza tu suscripción a UBISOFT+, tendrás que comprar el Season Pass para cargar cualquiera de tus archivos guardados (incluida tu progresión actual en el juego). Para obtener más información, revisa estos artículos {here}.",
        "warning.savefiles_alert.body.here": "aquí",
        "warning.savefiles_alert.cancel": "Atrás",
        "warning.savefiles_alert.confirm": "Confirmar",
        "warning.mobile_launch_alert.body": "{game} ha sido añadido a tus juegos. Inicia Uplay en tu PC para jugarlo.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "Condiciones de la Suscripción",
        "footer.links.privacy_policy_label": "POLÍTICA DE PRIVACIDAD",
        "footer.links.legal_label": "INFORMACION LEGAL",
        "hero.title": "Servicio de Suscripción de Ubisoft",
        "hero.subtitle": "ACCESO ILIMITADO A +100 JUEGOS | Cancela en cualquier momento",
        "hero.buttons.subscribe": "Suscríbete ya",
        "hero.buttons.login": "Inicia sesión",
        "hero.buttons.browse": "Ver todos los juegos",
        "progression.benefits.description": "Desbloquea nuestros mundos y conquista los tuyos. ¡Queremos recompensarte por tu apoyo! Consigue nuevas recompensas in-game cada mes.\r\n¡Cuanto más te quedes en Ubisoft+, más recompensas in-game podrás conseguir!",
        "progression.benefit.singular.reward": "recompensa",
        "progression.benefit.plural.reward": "recompensas",
        "progression.benefit.singular.benefit": "beneficio",
        "progression.benefit.plural.benefit": "beneficios",
        "progression.benefit.singular.booster": "potenciador",
        "progression.benefit.plural.booster": "potenciadores",
        "progression.level.subscribed_for": "Te has suscrito durante",
        "progression.level.new_subscriber": "Nuevo suscriptor",
        "progression.level.new_subscribers": "Nuevos suscriptores",
        "progression.level.subscription.first_month": "1er mes",
        "progression.level.subscription.starting_with_months": "{months}+ meses",
        "general.date.month": "mes",
        "general.date.months": "meses",
        "general.date.month_remaining": "mes restante",
        "general.date.months_remaining": "meses restantes",
        "rewards.monthly_rewards": "Tus recompensas mensuales",
        "rewards.trial_info": "Free trial",
        "rewards.left": "{time_left} restantes para canjear {rewards_left} recompensa(s) este mes",
        "rewards.current_title": "Recompensas actuales",
        "rewards.previous_title": "Recompensas pasadas",
        "rewards.upcoming_title": "Próximas recompensas",
        "rewards.none_found": "No se han encontrado recompensas",
        "rewards.available": "Disponible",
        "rewards.locked": "Bloqueado",
        "rewards.claimed": "Canjeado",
        "rewards.claim": "Sí",
        "rewards.cancel": "Cancelar",
        "rewards.confirm": "¿Quieres canjear la recompensa?",
        "rewards.none_left": "No puedes canjear más recompensas",
        "rewards.already_claimed": "Ya reclamaste esta recompensa",
        "rewards.claim_confirm": "Esta recompensa ya está disponible en tu juego",
        "rewards.close": "Cerrar",
        "rewards.load_more": "Cargar más",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "More Info",
        "external.links.actions.learn_more": "Learn More"
    }
};